import * as Immutable from "immutable";

import { Overlay } from "./Overlay";
import { Actions, IAction } from "./types";

export class ActionCentre {

    private globalState: Immutable.Map<any, any>;

    constructor(state: Immutable.Map<any, any>) {
        this.globalState = state;
    }

    public Do(action: IAction) {
        let overlay: Overlay = null;

        switch (action.Type) {
            case Actions.SHOW_OVERLAY:
                if (!overlay) { overlay = new Overlay(); }            
                overlay.ShowOverlay();
                this.globalState = this.ProcessState(action.Payload[0], action.Payload[1], this.globalState);
                break;
            case Actions.HIDE_OVERLAY:
                if (!overlay) { overlay = new Overlay(); }
                overlay.HideOverlay();
                this.globalState = this.ProcessState(action.Payload[0], action.Payload[1], this.globalState);
            default:
                break;                
        }
    }

    public GetStateValue(key): any {
        return this.globalState.get(key);
    }

    private ProcessState(key: string, value: any, map: Immutable.Map<any, any>): Immutable.Map<any, any> {
        return map.set(key, value);
    }
}



// WEBPACK FOOTER //
// ./src/global/ActionCentre.ts